import { CssBaseline, ThemeProvider } from "@mui/material";
import { getTheme } from "@src/appV2/redesign/system/ui-theme";
import { type ReactElement } from "react";
import { Route, Switch, useRouteMatch } from "react-router-dom";

import { PlacementChatPage } from "../PlacementChats/PlacementChatPage";
import { WorkplaceModalsDataProvider } from "../ShiftDiscovery/useWorkplaceModalsDataContext";
import { BanDisputePage } from "./components/DisputeBan/DisputeBanPage";
import { PlacementDetailsPageV2 } from "./components/PlacementDetailsPage/PlacementDetailsPageV2";
import { PlacementReferralPage } from "./components/PlacementReferrals/Page";
import { PlacementsRootPage } from "./RootPage";
import { WorkplaceModalRoutes } from "./WorkplaceModalRoutes";

export function PlacementRoutes(): ReactElement {
  const match = useRouteMatch();

  const isInterviewsOutcome = useRouteMatch(`${match.url}/interviews/outcome`);
  const detailsOrChatMatch = useRouteMatch(`${match.url}/:placementId`);

  const isInDetailsOrChat = Boolean(detailsOrChatMatch) && !isInterviewsOutcome;

  return (
    <>
      <ThemeProvider theme={getTheme()}>
        <CssBaseline />

        <WorkplaceModalsDataProvider baseNavigationPath={match.url}>
          <WorkplaceModalRoutes />
        </WorkplaceModalsDataProvider>
      </ThemeProvider>

      <Switch>
        <Route path={`${match.url}`}>
          <Route path={`${match.url}`}>
            {/* Always mounted, but hides itself when a detail/chat page is open. */}
            <PlacementsRootPage hidden={isInDetailsOrChat} />
          </Route>
          <Switch>
            <Route exact path={`${match.url}/dispute-ban/:banId`}>
              <BanDisputePage />
            </Route>
            <Route exact path={`${match.url}/:placementId`}>
              <WorkplaceModalsDataProvider baseNavigationPath={match.url}>
                <PlacementDetailsPageV2 />
              </WorkplaceModalsDataProvider>
            </Route>
            <Route
              exact
              path={`${match.url}/:placementId/placement-candidate/:placementCandidateId`}
            >
              <WorkplaceModalsDataProvider baseNavigationPath={match.url}>
                <PlacementDetailsPageV2 />
              </WorkplaceModalsDataProvider>
            </Route>
            <Route path={`${match.url}/:placementId/referrals`}>
              <PlacementReferralPage />
            </Route>
            <Route path={`${match.url}/:placementId/workplace/:workplaceId/chat`}>
              <PlacementChatPage />
            </Route>
          </Switch>
        </Route>
      </Switch>
    </>
  );
}
